import { render, staticRenderFns } from "./LicenseOverlay.vue?vue&type=template&id=432c5924&scoped=true"
import script from "./LicenseOverlay.vue?vue&type=script&lang=js"
export * from "./LicenseOverlay.vue?vue&type=script&lang=js"
import style0 from "./LicenseOverlay.vue?vue&type=style&index=0&id=432c5924&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432c5924",
  null
  
)

export default component.exports